/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React, { useEffect, useState, useRef } from "react"
import s from "../css/products.module.css"
import imgSoldout from "../../../../../images/soldout.png"
import PriceItem from "./price-item"
import { urls } from "../../../../../constants"

const ProductItemCard = ({ project, product, dataImages, onPrezzoClick }) => {

  const produtImageList = useRef([]);
  const [selectedProductImage, setSelectedProductImage] = useState(null);

  useEffect(() => {

    produtImageList.current = product.images.reduce((prev, curr, currIndex) => {
      let img = dataImages.allFile.edges.find(e => e.node.base.indexOf(`${curr}.`) === 0);
      if (img) {
        prev.push(img);
      }
      return prev;
    }, []);

    setSelectedProductImage(produtImageList.current.length > 0 ? produtImageList.current[0] : null);
  }, [])

  return (
    <>
      <div className={`relative flex flex-col container-grid ${s.container}`} style={{ marginTop: '70px' }}>
        <div className="col-span-4 desktop:col-span-6 font-rg text-6" style={{ color: '#141414', lineHeight: '21px', backgroundColor: '#f5f5f5' }}>
          <div className="flex flex-row desktop:flex-col desktop:items-center" style={{ padding: '30px' }}>
            <div className="flex items-start desktop:justify-center">
              {selectedProductImage && <img src={selectedProductImage.node.publicURL} style={{ objectFit: 'contain' }} alt="prodotto" />}
            </div>
            <div className={`${s.productItemsThumbnailsContainer}`} style={{ marginTop: '24px' }}>
              <div className={`flex flex-col desktop:flex-row desktop:mx-auto`}>
                {produtImageList.current.map(s => <img src={s.node.publicURL} className="desktop:mr-16" style={{ height: '50px', objectFit: 'contain', backgroundColor: 'white' }} onClick={() => { setSelectedProductImage(s) }} />)}
              </div>
            </div>
          </div>
        </div>
        <div className={`flex flex-col col-span-4 desktop:col-start-7 desktop:col-end-13 ${s.detailsContainer}`}>
          <div className={`flex-grow ${s.textDetailsContainer}`}>
            <div className="text-5 leading-8 desktop:text-24 desktop:leading-18 font-md text-black">
              {product.title}
              {product.soldout && <>
                <br />(Sold Out)
              </>}
            </div>
            <div className="text-7 leading-6 desktop:text-6 desktop:leading-6_1 text-black" style={{ marginTop: '26px' }} dangerouslySetInnerHTML={{ __html: product.description }}></div>
          </div>
          <div className={`mt-p18 desktop:mt-p25 ${s.textDetailsContainer}`}>
            <div className="text-5 leading-8 text-primary font-bd desktop:text-5" style={{ marginTop: '4px' }}><a onClick={() => { onPrezzoClick(false, 'link', null) }}>Solo con Tinaba. Scarica ora l’app e registrati con il codice {project.promocode}!</a></div>
          </div>
          <div className={`mt-2 flex flex-row ${product.soldout ? 'opacity-20' : ''}`} style={{ height: '81px' }}>
            {product.price !== undefined && <PriceItem price={product.price} soldout={product.soldout} onClick={() => { onPrezzoClick(false, 'product', product) }} />}
            {product.price_tinaba !== undefined && <PriceItem price={product.price_tinaba} soldout={product.soldout} isTinaba onClick={() => { onPrezzoClick(true, 'product', product) }} />}
          </div>
        </div>

        {product.soldout && <div className={s.soldout}><img src={imgSoldout} className={`${s.imgSoldout}`} alt="soldout" /></div>}
      </div>
    </>
  );
}

export default ProductItemCard
